import { MapPin, Clock } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="cv-seccion" aria-label={seccion.titulo}>
      <div className="cv-seccion-interior">
        <EncabezadoSeccion p="cv" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="cv-titulo-eventos" />
        <div className="cv-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="cv-evento" data-testid={`cv-evento-${ev.id || i}`}>
                <p className="cv-evento-hora">{ev.horario}</p>
                <div className="cv-evento-cuerpo">
                  <p className="cv-evento-etiqueta">{ev.etiqueta}</p>
                  <h3 className="cv-evento-nombre">{ev.lugar}</h3>
                  <p className="cv-evento-detalle">
                    <MapPin strokeWidth={1.5} />
                    <span>{ev.direccion}</span>
                  </p>
                  {ev.urlUbicacion && (
                    <a
                      className="cv-boton"
                      href={ev.urlUbicacion}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`cv-boton-ubicacion-${ev.id || i}`}
                    >
                      <MapPin strokeWidth={1.5} />
                      {ev.textoBoton || "Cómo llegar"}
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
